// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"206":"1ddfbbb0","757":"1ddfbbb0"}[chunkId] + ".css";
};